<template>
  <div>
    <Header title="空闲教室查询" type="0" route="/homeIndex"></Header>
    <div class="research">
      <span @click="timePicker = true">
        <i>时间：{{ date }}</i>
        &nbsp;&nbsp;
        <b></b>
      </span>
      <span @click="showPicker = true">
        <i>节次：{{ qsjc }}{{this.fjxsj==""?"节":""}}</i>
        &nbsp;&nbsp;
        <b></b>
      </span>
      <span @click="goMore">
        更多&nbsp;
        <i class="iconfont icongengduo icon"></i>
      </span>
    </div>
    <NOdata
      v-if="this.classroomList && this.classroomList.length == 0"
      title="未查询到空闲教室"
    ></NOdata>
    <div v-else class="content">
      <span v-for="(item, index) in classroomList" :key="index">
        <div v-for="cItem in item.classroomList" :key="cItem.classroomId">
          <p>
            {{ item.teachingBuildingName }} {{ cItem.classroomname }}
            {{ cItem.classroomnumber }}
          </p>
          <ul style="margin-bottom:10px">
            <li>容量：{{ cItem.seatnumber }}人</li>
          </ul>
          <button class="inquire_btn" @click="ToBorrowr(item,cItem)" v-if="canBorrow && schoolCode != '12609'">借用</button>
          <button class="inquire_btn" style="float: right;margin-right: 20px;" @click="scjs(cItem)" v-if="schoolCode == '14475' && cItem.sfsc == '0'">收藏</button>
          <button class="inquire_btn" style="float: right;margin-right: 20px;background: #ee0a24" v-if="schoolCode == '14475' && cItem.sfsc == '1'">已收藏</button>
          <!-- <span class="iconfont icon iconicon-test"></span> -->
        </div>
      </span>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="qsjcList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="timePicker" position="bottom" class="date-pick-item">
      <van-datetime-picker
        show-toolbar
        v-model="currentDate"
        type="date"
        :min-date="startDate"
        :max-date="endDate"
        @cancel="timePicker = false"
        @confirm="timeConfirm"
        :swipe-duration="100"
      />
    </van-popup>
  </div>

</template>

<script>
import { Api } from "@/utils/axios";

import Vue from "vue";
import { Picker } from "vant";

Vue.use(Picker);
export default {
  data() {
    return {
      fjxsjdm:"",
      fjxsj:"",
      start: "01",
      end: "02",
      qsjc: "",
      date: "",
      qsjcList: [
        {
          values: [],
          className: "column1"
        },
        {
          values: [],
          className: "column2",
          defaultIndex: 1
        }
      ],
      showPicker: false,
      timePicker: false,
      currentDate: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      classroomList: [],
      canBorrow:false,
      schoolCode: sessionStorage.getItem("schoolCode")
    };
  },
  methods: {
    goMore() {
      this.$router.push({
        path: "/restRooms/roomMore",
        query: {
          s_start: this.start,
          e_end: this.end,
          d_date: this.date,
          // 教学楼
          jxl: {
            mc: this.$route.query.bName,
            dm: this.$route.query.build
          },
          // 校区
          xq: {
            mc: this.$route.query.cName,
            dm: this.$route.query.campus
          },
          // 教室类型
          jslx: {
            mc: this.$route.query.jslx,
            dm: this.$route.query.rType
          },
          //非教学实践
          fjxsjdm: this.fjxsjdm,
          fjxsj: this.fjxsj
        }
      });
    },
    // 查询教室
    async researchRoom() {
      let type = this.$route.query.type;
      let params = {};
      if (type !== "1") {
        params = {
          date: this.$route.query.date,
          nodeId: this.start + this.end,
          buildingId: this.$route.query.build,
          campusId: this.$route.query.campus,
          jslx: this.$route.query.rType,
          fjxsjdm:this.fjxsjdm
        };
      } else {
        params = {
          date: this.$route.query.date,
          nodeId: this.$route.query.time,
          buildingId: this.$route.query.build,
          campusId: this.$route.query.campus
        };
      }
      // console.log(params);
      const res = await Api.getIdleClassroom(params);
      this.classroomList = res.data;
      if (res.data.length == 0) {
        this.$toast("未查询到空闲教室~");
      }
    },
    // 获取起始节次列表
    async getNode() {
      const res = await Api.getNodeList();
      let concatList = [];
      this.canBorrow = res.studentCanBorrow=='1'?true:false;
      for (let i = 0; i < res.data.length; i++) {
        concatList = concatList.concat("第" + res.data[i].nodeName + "小节");
        this.qsjcList[0].values = concatList;
        this.qsjcList[1].values = concatList;
      }
      this.qsjc = this.start + "-" + this.end;
    },
    // 选择节次时间
    onConfirm(value) {
      this.start = value[0].substr(1, value[0].length - 3);
      this.end = value[1].substr(1, value[0].length - 3);
      let begin = Number(this.start);
      let over = Number(this.end);
      if (begin > over) {
        this.$toast.fail("开始节次不能大于结束节次");
      } else {
        this.showPicker = false;
        this.qsjc = this.start + "-" + this.end;
      }
      this.fjxsj="";
      this.fjxsjdm="";
      this.researchRoom();
    },
    // 获取最大最小时间
    async getMinMaxDate() {
      const res = await Api.getGgjxzlDate();
      let end = res.data[0].endDate.match(/\d?(.\d+)/gi);
      this.endDate = new Date(
        end[0] +
          "/" +
          Number(end[1].substr(1, end[1].length)) +
          "/" +
          Number(end[2].substr(1, end[1].length))
      );
      if (this.endDate < new Date()) {
        this.startDate = this.endDate;
      }
      if (this.$route.query.type != "0") {
        this.date =
          this.startDate.getFullYear() +
          "-" +
          (this.startDate.getMonth() + 1 < 10
            ? "0" + (this.startDate.getMonth() + 1)
            : this.startDate.getMonth() + 1) +
          "-" +
          (this.startDate.getDate() < 10
            ? "0" + this.startDate.getDate()
            : this.startDate.getDate());
      }
    },
    // 选择时间
    timeConfirm(res) {
      let calDate = res.getDate();
      if (res.getDate() < 10) {
        calDate = "0" + res.getDate();
      }
      this.date =
        res.getFullYear() +
        "-" +
        (res.getMonth() + 1 < 10
          ? "0" + (res.getMonth() + 1)
          : res.getMonth() + 1) +
        "-" +
        calDate;
      this.timePicker = false;
      this.researchRoom();
    },
    ToBorrowr(itObj,ctObj){
      let startNode = this.start;
      let endnode = this.end;
      this.$router.push({
        path: "/classroom3",
        query: {
          //starToEndNode:this.qsjc,
          //classroomid: ctObj.classroomId,
          //teachingBuildingName:itObj.teachingBuildingName,
          //classroomname:itObj.classroomname,
         // classroomnumber:ctObj.classroomnumber,
          //seatnumber:ctObj.seatnumber,
          //borrwdate:this.date,
          //ywcode: '007',
          //startNode:startNode,
          //weeknode:"",
          //endnode:endnode,
          //isStudentBorrw:"1"

          startNode: startNode, //开始节次
          endnode: endnode, //结束节次
          classroomCapacity: ctObj.seatnumber, //教室容量
          teachingBuildingName: itObj.teachingBuildingName,
          classroomName: itObj.classroomname,
          classroomNumber: ctObj.classroomnumber,
          seatNumber: ctObj.seatnumber,
          borrwdate:this.date,
          id: ctObj.classroomId,
          week: "",
          day: "",
          bz: "",
          weeknode: '',
          params: {},
          ywcode: '007',
          isStudentBorrw:"1",
          fjxsjdm:this.fjxsjdm
        }
      });

    },
    async scjs(item){
      const param = {jsid:item.classroomId};
      const res = await Api.kxscjs(param)
      if(res.code == '1'){
        this.$toast.success('收藏成功!')
        setTimeout(()=>{
          this.researchRoom();
        })
      }else{
        this.$toast(res.Msg)
      }
    }
  },
  async created() {
    // 获取最大最小时间
    await this.getMinMaxDate();
    // 获取起始节次列表
    await this.getNode();

    let type = this.$route.query.type;
    if (type == "0") {
      this.start = this.$route.query.start;
      this.end = this.$route.query.end;
      this.date = this.$route.query.date;
      this.qsjc = this.start + "-" + this.end;
      if (this.schoolCode == "10534" || this.schoolCode == "12649") {
        this.fjxsjdm = this.$route.query.fjxsjdm;
        this.fjxsj = this.$route.query.fjxsj;
        if (this.fjxsj) {
          this.qsjc = this.fjxsj
        }
      }
    }

    await this.researchRoom();
  }
};
</script>
<style lang="less" scoped>
.research {
  z-index: 9999;
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  border-bottom: 1px solid #f4f4f4;
  padding: 5% 5% 3% 5%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: #fff;

  span {
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #757da3;
    letter-spacing: 0;
    text-align: right;
    display: inline-flex;
    align-items: center;
    i {
      font-style: normal;
    }
    b {
      display: inline-block;
      border-right: 3px solid transparent;
      border-left: 3px solid transparent;
      border-top: 3px solid #757da3;
    }
  }
}
.content {
  padding: 60px 5% 0;

  div {
    background: #f8f8f8;
    border-radius: 5px;
    padding: 3% 0 3% 6%;
    margin-bottom: 5%;
    position: relative;

    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      font-weight: bolder;
      margin-bottom: 2%;
    }

    ul li {
      height: 17px;
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 1%;
    }
    span {
      position: absolute;
      top: calc(50% - 6px);
      right: 5%;
    }
  }
}
.icon {
  font-size: 12px;
}
.inquire_btn {
  width: 28%;
  height: 28px;
  background: rgba(116, 105, 248, 1);
  border-radius: 3px;
  font-size: 16px;
  font-weight: 500;
  color: @attendance-color-3;
}
.inquire{
  height: 32px;
  width: 50%;
  margin-bottom: 5px;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/newPages/student/restRooms/index.vue